import React, { useState, useContext } from "react";
import "./LoginPage.styles.css";
import { Link } from "react-router-dom";
import darkLogo from "../../assets/images/dark-logo.png";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AnimationSpinner from "../../AnimationSpinner";
import GetToken from "../../GetToken";
import { AppContext } from "../../context/AppContext";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
// import LoginImage from "../../assets/images/loginPage/loginPageImage3.png";
import LoginImage from "../../assets/images/loginPage/Flipbook.jpg";
import { toast } from "react-toastify";
const LoginPage = (props) => {
	const { fetchMenuPermissions, clearPermissions } = useContext(AppContext);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const [showPassword, setShowPassword] = useState(false);

	const handleShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		if (email.trim() === "" || password.trim() === "") {
			const text =
				email.trim() === "" && password.trim() === ""
					? "Email and Password are required."
					: email.trim() === ""
						? "Email is required."
						: "Password is required.";
			toast.error("Warning...");
			// Swal.fire({
			// 	icon: "error",
			// 	title: "Warning...",
			// 	text: text,
			// });
			return;
		}
		setLoading(true);
		const auth = new FormData();
		auth.append("email", email);
		auth.append("password", password);
		clearPermissions();
		axios
			.post(`${props.base_url}authentication`, auth)
			.then((res) => {
				if (res.data.status === true) {
					localStorage.setItem("activeusertoken", res.data.token);
					localStorage.setItem("username", res.data.username);
					localStorage.setItem("avatar", res.data.avatar);
					localStorage.setItem("email", res.data.email);
					// fetchMenuPermissions(token, props.base_url, setPermissions);
					fetchMenuPermissions();
					setTimeout(() => {
						navigate("/dashboard", { replace: true });
						setLoading(false);
					}, 500);
				} else {
					setLoading(false);
					toast.error( "Login Failed...");
					// Swal.fire({
					// 	icon: "error",
					// 	title: "Login Failed...",
					// 	text: res.data.message,
					// });
				}
			})
			.catch((err) => {
				setLoading(false);
				toast.error("An error occurred during login. Please try again.");
			});
	};
	return (
		<>
			<div className="min-vh-100 login-gradient d-flex align-items-center justify-content-center p-4" style={{ background: "linear-gradient(233deg, rgba(242, 234, 234, 0.91) 19%, rgba(247, 247, 247, 0.94) 85%)" }}>
				<div className="main-login-container rounded-3 overflow-hidden position-relative shadow" >
					<div className="row h-100 g-0 login-content">
						{/* left side -image */}
						<div className="col-lg-6 d-none d-lg-block position-relative">
							<div className="login-img-container">
								<img
									src={LoginImage}
									alt="Team collaboration"
									layout="fill"
									className="rounded-end-3"
								/>
							</div>
						</div>
						{/* right Side - Form */}
						<div className="left-login-container col-lg-6 col-md-10 mx-auto p-4 p-lg-5">
							<div className="mb-4 mb-lg-4 text-center">
								<div className="loginPage-logo-container mx-auto">
									<img src={darkLogo} alt="BookFlow" />
								</div>
							</div>

							<div className="mb-4 text-center">
								<h1 className="h4">Sign in to your account</h1>
								<p className="text-muted">Welcome back! Please enter your details.</p>
							</div>

							<form onSubmit={handleSubmit}>
								<div className="mb-3">
									<label htmlFor="email" className="form-label small text-muted fw-semibold">
										Email
									</label>
									<input
										type="text"
										id="email"
										name="email"
										placeholder="xyz@gmail.com"
										className="form-control login"
										value={email}
										onChange={({ target: { value } }) =>
											setEmail(value)
										}

									/>
								</div>

								<div className="mb-4">
									<label htmlFor="password" className="form-label small text-muted fw-semibold">
										Password
									</label>
									<div className="position-relative">
										<input
											type={!showPassword ? "password" : "text"}
											id="password"
											name="password"
											placeholder="Password"
											className="form-control login"
											value={password}
											onChange={({ target: { value } }) =>
												setPassword(value)
											}

										/>
										<div
											className="login-input-icon position-absolute"
											onClick={handleShowPassword}
											style={{ cursor: "pointer" }}
										>
											{showPassword ? (
												<FaRegEyeSlash />
											) : (
												<FaRegEye />
											)}
										</div>
									</div>
								</div>

								<button type="submit" className="btn w-100 text-white" style={{ backgroundColor: "rgb(111, 9, 81)" }}>
									Login
								</button>
							</form>
							<div className="mt-3">
								<Link to="/forgot-password-request" className="login-link">
									Forgot password?
								</Link>
							</div>
						</div>


					</div>
				</div>
			</div>
		</>
	);
};

export default LoginPage;
